module.exports = __webpack_public_path__ + "tables/media/caret-active.3ca0b1e1.svg";